"use client";
import { Table, Image } from "antd";
import { useState } from "react";
import ThemeLink from "@/components/link";

const columns = [
    {
        title: '产品型号',
        dataIndex: 'model',
        key: 'model',
        align: 'center'
    },
    {
        title: '类别',
        dataIndex: 'category',
        key: 'category',
        align: 'center'
    },
    {
        title: '类型',
        dataIndex: 'type',
        key: 'type',
        align: 'center'
    },
    {
        title: '锁紧类型',
        dataIndex: 'lockingType',
        key: 'lockingType',
        align: 'center'
    },
    {
        title: '操作',
        key: 'action',
        align: 'center',
        render: (record: any) => {
            // 预留逻辑，后续调转商品详情页面
            const href = ''
            return <ThemeLink href={`/${href}`}>去询价</ThemeLink>
        },
    },
];

type Props = {
    resultList: any[];
}

export default function ProductViewer({ resultList }: Props) {
    return <div className="bg-[#f5f7fa] mt-[26px]">
        <div className="px-[30px] pt-[20px] pb-[50px] bg-white">
            <div className="flex flex-row items-center">
                <img className="w-[24px] h-[24px]" src={"/calculation-selection/debugging.png"} />
                <span className="ml-2 text-2xl text-[#333333] font-bold">选型结果</span>
            </div>
            {/* @ts-ignore */}
            <Table className="selection-results-table mt-[20px] " dataSource={resultList} columns={columns} bordered center pagination={{ hideOnSinglePage: true }} />
        </div>
    </div>
}